var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "plan" }, [
    _vm.showTitle || _vm.showSettings
      ? _c(
          "div",
          {
            class: [
              _vm.showTitle
                ? "titolo navy--text text--lighten-2 pb-1 font-hemi-head d-flex align-center"
                : "plan-settings-toolbar",
            ],
          },
          [
            _vm.showTitle
              ? _c("div", [_vm._v("Pianificazione Rosa")])
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                staticClass:
                  "section-title-action-btn navy darken-3 navy--text text--lighten-3 px-2 ml-1",
                attrs: {
                  "x-small": "",
                  rounded: "",
                  depressed: "",
                  title: "Impostazioni pianificazione",
                },
                on: { click: _vm.promptDialogPlanSettings },
              },
              [_c("v-icon", { attrs: { "x-small": "" } }, [_vm._v("tune")])],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showTitle && _vm.showButtonRose
      ? _c(
          "div",
          { staticClass: "d-flex justify-center" },
          [
            _c(
              "v-btn",
              {
                staticClass: "px-4 font-weight-bold white--text",
                attrs: { small: "", color: "primary" },
                on: { click: _vm.showDialogRoseLega },
              },
              [
                _c(
                  "v-icon",
                  { attrs: { small: "", left: "", color: "white" } },
                  [_vm._v("groups")]
                ),
                _vm._v("\n      Rose\n      "),
                _c(
                  "v-icon",
                  { attrs: { small: "", right: "", color: "white" } },
                  [_vm._v("chevron_right")]
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.my_squadra
      ? _c("div", { staticClass: "pa-10" }, [
          _vm._v(
            "\n      Attenzione. Solo i partecipanti all'asta possono pianificare le\n      strategia di acquisto\n    "
          ),
        ])
      : _c(
          "div",
          { staticClass: "plan-content" },
          [
            _c("asta-consiglio"),
            _vm._v(" "),
            _c(
              "v-list",
              {
                staticClass: "recycle-scroller",
                class: { "nice-scroll": !_vm.is_mobile },
              },
              _vm._l(_vm.myPlan, function (slots, ruolo_abc) {
                return _c(
                  "div",
                  { key: ruolo_abc },
                  [
                    _vm._l(slots, function (slotData, slot, i) {
                      return _c("asta-slot", {
                        key: ruolo_abc + "_" + slot,
                        attrs: { ruolo_abc: ruolo_abc, iSlot: slot, i: i },
                      })
                    }),
                    _vm._v(" "),
                    (_vm.acquistiSenzaSlotPerRuolo[ruolo_abc] || []).length >
                    _vm.slotLiberi(ruolo_abc).length
                      ? _c(
                          "div",
                          {
                            staticClass: "plan-fuori-limite",
                            style: {
                              "--plan-role-color":
                                "var(--ruolo-" +
                                _vm.Constants.RUOLO[ruolo_abc] +
                                ")",
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "plan-fuori-limite-title font-weight-bold px-2",
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(ruolo_abc) +
                                    " — Acquistati senza slot\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            ["=", "<="].includes(_vm.asta_info.lega.nRuoli.op)
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "px-2 pb-2 text-caption",
                                    attrs: { role: "alert" },
                                  },
                                  [
                                    _c(
                                      "v-icon",
                                      {
                                        staticClass: "plan-fuori-limite-title",
                                        attrs: { "x-small": "" },
                                      },
                                      [_vm._v("warning")]
                                    ),
                                    _vm._v(
                                      "\n              Gli slot disponibili non bastano per tutti gli acquistati.\n              Può succedere se l’amministratore riduce troppo il numero di calciatori\n              acquistabili per questo ruolo dopo che le assegnazioni erano giá avvenute in Asta Live.\n              Chiedi all’amministratore di verificare il limite impostato e di aumentarlo (oppure eliminare le assegnazioni in eccesso)\n            "
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(
                              _vm.acquistiSenzaSlotPerRuolo[ruolo_abc],
                              function (id) {
                                return _c(
                                  "div",
                                  {
                                    key: "senza-slot-" + id,
                                    staticClass: "plan-acquistato-senza-slot",
                                  },
                                  [
                                    _c("maglia-or-flag-plus-nome", {
                                      attrs: { calciatore: _vm.calciatori[id] },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "plan-acquistato-nome" },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.calciatori[id].calciatore)
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("crediti", {
                                      attrs: {
                                        crediti:
                                          _vm.my_squadra.calciatori[id].p || 0,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _vm.slotLiberi(ruolo_abc).length
                                      ? _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              "x-small": "",
                                              outlined: "",
                                              rounded: "",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.associaAcquistato(id)
                                              },
                                            },
                                          },
                                          [_vm._v("Associa")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }
                            ),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  2
                )
              }),
              0
            ),
            _vm._v(" "),
            _c("asta-plan-numpad"),
            _vm._v(" "),
            _c("dialog-associa-calciatore"),
            _vm._v(" "),
            _c("dialog-associa-slot"),
            _vm._v(" "),
            _c("dialog-plan-settings"),
            _vm._v(" "),
            _c("dialog-plan-strategia"),
            _vm._v(" "),
            _c("dialog-plan-obiettivo"),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }